export const messages = {
    cs: {
        ride_not_found: "Jízda nebyla nalezena",
        loading: "Načítám…",
        delivery_arriving_time: "Zásilka přijede {time}",
        delivery_arriving_time_at: "Zásilka přijede kolem {time}",
        delivery_arriving_no_time: "Zásilka je na cestě",
        delivery_arriving_soon: "Zásilka přijede za okamžik",
        delivery_delay: "Zpoždění doručení {delay} min",
        delivery_finished: "Zásilka byla doručená",
        delivery_undelivered:
            "Zásilku se nepodařilo doručit. Kurýr vás nezastihl nebo bylo doručení zrušeno.",
        delivery_redirected: "Zásilka je na cestě na výdejní místo",
        delivery_delivered_to_pudo: "Zásilka je uložena na výdejním místě",
        delivery_arrived: "Kurýr je na místě doručení",
        delivery_cancelled:
            "Zásilku se nepodařilo doručit. Kurýr Vás nezastihl nebo bylo doručení zrušeno.",
        order_cancelled: "Objednávka byla zrušena",
        order_cancelled_by_courier: "Objednávka byla zrušena kurýrem",
        pickup_arriving_time: "Vyzvednutí zásilky {time}",
        pickup_arriving_time_at: "Vyzvednutí zásilky kolem {time}",
        pickup_arriving_no_time: "Kurýr je na cestě",
        pickup_arriving_soon: "Vyzvednutí zásilky za okamžik",
        pickup_delay: "Zpoždění vyzvednutí {delay} min",
        pickup_finished: "Zásilka byla vyzvednuta",
        pickup_undelivered: "Vyzvednutí bylo zrušeno",
        pickup_arrived: "Kurýr je na místě",
        pickup_cancelled: "Vyzvednutí bylo zrušeno",
        black: "Černá",
        blue: "Modrá",
        brown: "Hnědá",
        green: "Zelená",
        orange: "Oranžová",
        purple: "Fialová",
        red: "Červená",
        silver: "Stříbrná",
        white: "Bílá",
        yellow: "Žlutá",
        car_name: "{brand} {model}",
        destination: "Cíl",
        pcs: "ks",
        call: "Volat kurýrovi",
        call_courier: "Zavolat kurýrovi",
        privacy_policy: "Zásady ochrany osobních údajů",
        package_redirecting: "Pokyny k vyzvednutí obdržíte od společnosti {ordererName}.",
        pudo_name: "Výdejní místo",
        pudo_address: "Adresa",
        show_pudo_image: "Zobrazit obrázek",
        hide_pudo_image: "Skrýt obrázek",
        code: "Kód",
        call_courier_dialog_title_ivr_disabled:
            "Kurýrovi se dovoláte pouze z čísla uvedeného při objednávce",
        call_courier_dialog_title_ivr_enabled: "Volat kurýrovi",
        call_courier_dialog_subtitle:
            "Pro zvýšenou ochranu soukromí nezobrazujeme skutečná telefonní čísla.",
        code_for_communication: "Kód pro komunikaci",
        pickup: "Vyzvednutí",
        delivery_drop_off: "Doručení",
        stop: "Zastávka",
        depot: "Uložení",
        return: "Vrácení",
        delivered: "Doručeno",
        redirected: "Přesměrováno",
        delivered_to_pudo: "Doručeno na výdejní místo",
        undelivered: "Nedoručeno",
        picked_up: "Vyzvednuto",
        returned: "Vráceno",
        understand: "Rozumím",
        message_sent_title: "Zpráva odeslána",
        message_sent_info: "Kurýr dostal vaši zprávu.",
        message_sent_description: "Odeslanou zprávu nelze upravit.",
        courier_cancelled: "Doručení zrušeno",
        cancelled: "Zrušili jste doručení",
        cancelled_info:
            "Zásilka se vrací zpět společnosti {ordererName}. Napište nám, co se stalo. Pomůžete nám tím zlepšit službu.",
        redirected_to_pudo: "Přesměrovali jste doručení",
        redirected_to_pudo_info:
            "Vaše zásilka bude čekat na nejbližším volném výdejním místě nebo boxu. Přesné informace k vyzvednutí zásilky vám dá společnost {ordererName}.",
        delay: "zpoždění",
        soon: "za okamžik",
        arrived: "na místě",
        change_title_question: "Jak chcete změnit doručení?",
        change_delivery_intent: "Změna doručení",
        cancel_title_question: "Zrušit doručení",
        cancel_delivery_intent: "Zrušit doručení",
        cancel_delivery_description: "Upravte dnešní doručení a kurýr vás nebude hledat zbytečně.",
        cancel_delivery_question: "Proč měníte doručení?",
        cancel_delivery: "Zrušit doručení",
        confirm_redirect_to_pudo: "Potvrdit změnu",
        select_the_reason: "Zvolte důvod",
        redirect_info: "Nejbližší volné výdejní místo určuje společnost {ordererName}.",
        cancel_failed: "Zrušení se nezdařilo",
        show_message_to_courier: "Zobrazit vaši zprávu",
        message_to_courier: "Zpráva kurýrovi",
        message_to_courier_description:
            "Pošlete dodatečné instrukce k předání zásilky. Kurýři nemohou odepsat.",
        message_placeholder: "Například: Zásilku bude přebírat manželka, zvonek Novákovi",
        message_maximum_characters: "Zadejte maximálně {MAX_CHARS} znaků",
        send_message: "Odeslat zprávu",
        send_message_failed: "Odeslání se nezdařilo",
        message_sent: "Zpráva odeslána",
        message_cant_be_edited: "Odeslanou zprávu nelze upravit",
        back: "Zpět",
        czk: "Kč",
        pln: "zł",
        tip_for_courier: "Spropitné pro kurýra",
        tip_for_courier_description: "Kurýr dostane 100% z darované částky",
        tip_range_hint: "Platný rozsah: {MIN} – {MAX} {CURRENCY}.",
        custom: "Jiné",
        tip: "Spropitné",
        receipt: "Účtenka",
        add_more: "Přidat další",
        ok: "OK",
        tip_payment_successful: "Platba úspěšná",
        tip_payment_successful_text: "Děkujeme za spropitné. Kurýrovi jsme právě poslali oznámení.",
        tip_payment_failed: "Platba se nezdařila",
        tip_payment_failed_text: "Můžete to zkusit znovu.",
        card_payment: "Zaplatit kartou",
        generic_error: "Něco se pokazilo. Prosím zkuste to znovu.",
        try_again: "Zkusit znovu",
        max_price_limit: "Spropitné nemůže být vyšší než {MAX_PRICE} Kč",
        courier_is_finishing_previous_job:
            "Kurýr právě dokončuje předchozí zakázku. Dorazí na místo v odhadovaném čase.",
        customer_service_contact_at_grid_page:
            "Zákaznickou podporu najdete na <a>www.grid.online/contact</a>",
        contact_page_url: "https://www.grid.online/contact",
        delivery_ordered_by: "Doručení objednal/a",
        how_was_the_ride: "Jaká byla vaše jízda?",
        feedback_customer_service_info: "Zákaznický servis se zabývá každou zpětnou vazbou",
        feedback_positive_title: "Co se vám obzvlášť líbilo?",
        feedback_neutral_title: "Co by se mělo zlepšit pro 5 hvězd?",
        feedback_negative_title: "To nás mrzí, co bylo špatně?",
        feedback_subtitle: "Vyberte prosím alespoň jeden důvod. Hodnocení je anonymní.",
        send_rating: "Odeslat hodnocení",
        sending: "Odesílání…",
        rating_failed: "Hodnocení se nepodařilo odeslat. Zkuste to prosím znovu.",
        add_comment: "Přidat komentář",
        comment: "Komentář",
        thank_you_for_rating: "Děkujeme za hodnocení",
        how_was_the_delivery: "Jaké bylo doručení?",
        please_select_a_reason: "Prosím vyberte důvod nebo přidejte komentář",
    },
    en: {
        ride_not_found: "Ride not found",
        loading: "Loading…",
        delivery_arriving_time: "The package will arrive {time}",
        delivery_arriving_time_at: "The package will arrive around {time}",
        delivery_arriving_no_time: "The package is on board",
        delivery_arriving_soon: "Package will arrive in a moment",
        delivery_delay: "Dropoff delay {delay} min",
        delivery_finished: "This delivery has finished",
        delivery_undelivered:
            "The package could not be delivered. The courier did not reach you or the delivery was cancelled.",
        delivery_redirected: "The package has been redirected",
        delivery_delivered_to_pudo: "The package is stored on parcel shop",
        delivery_arrived: "Courier arrived at dropoff location",
        delivery_cancelled:
            "The package could not be delivered. The courier did not reach you or the delivery was cancelled.",
        order_cancelled: "Order was cancelled",
        order_cancelled_by_courier: "Order was cancelled by courier",
        pickup_arriving_time: "Package pickup {time}",
        pickup_arriving_time_at: "Package pickup around {time}",
        pickup_arriving_no_time: "Courier is arriving",
        pickup_arriving_soon: "Package pickup soon",
        pickup_delay: "Pickup delay {delay} min",
        pickup_finished: "Package picked up",
        pickup_undelivered: "Pickup cancelled",
        pickup_arrived: "Courier just arrived",
        pickup_cancelled: "Pickup cancelled",
        black: "Black",
        blue: "Blue",
        brown: "Brown",
        green: "Green",
        orange: "Orange",
        purple: "Purple",
        red: "Red",
        silver: "Silver",
        white: "White",
        yellow: "Yellow",
        car_name: "{brand} {model}",
        destination: "Destination",
        pcs: "pcs",
        call: "Call courier",
        call_courier: "Call courier",
        privacy_policy: "Privacy policy",
        package_redirecting: "You will receive pickup instructions from the company {ordererName}.",
        pudo_name: "Pickup point",
        pudo_address: "Address",
        show_pudo_image: "Show picture",
        hide_pudo_image: "Hide picture",
        code: "Code",
        call_courier_dialog_title_ivr_disabled:
            "Contacting the courier is possible only from the number provided with the order",
        call_courier_dialog_title_ivr_enabled: "Call courier",
        call_courier_dialog_subtitle: "For extra privacy, we don't display real phone numbers.",
        code_for_communication: "Code for communication",
        pickup: "Pickup",
        delivery_drop_off: "Drop-off",
        stop: "Stop",
        depot: "Storing",
        return: "Return",
        delivered: "Delivered",
        undelivered: "Undelivered",
        picked_up: "Picked up",
        returned: "Returned",
        understand: "Got it",
        message_sent_title: "Message sent",
        message_sent_info: "The courier has received your message.",
        message_sent_description: "Sent message cannot be edited.",
        redirected: "Redirected",
        delivered_to_pudo: "Delivered to parcel shop",
        courier_cancelled: "Delivery cancelled",
        cancelled: "You have canceled the delivery",
        cancelled_info:
            "Shipment is being returned back to {ordererName}. Please let us know what happened. This will help us improve our service.",
        redirected_to_pudo: "You have redirected the delivery",
        redirected_to_pudo_info:
            "Your shipment will be waiting at the nearest available parcel shop or locker. The company {ordererName} will provide you with precise information for collecting the shipment.",
        delay: "delay",
        soon: "in a moment",
        arrived: "arrived",
        change_title_question: "How would you like to change the delivery?",
        change_delivery_intent: "Change delivery",
        cancel_title_question: "Cancel delivery",
        cancel_delivery_intent: "Cancel delivery",
        cancel_delivery_description:
            "Update your delivery so the courier won't try to reach you unnecessarily.",
        cancel_delivery_question: "Why are you changing the delivery?",
        cancel_delivery: "Cancel delivery",
        confirm_redirect_to_pudo: "Confirm change",
        select_the_reason: "Select a reason",
        redirect_info: "Nearest available pickup point is determined by the company {ordererName}",
        cancel_failed: "Cancel failed",
        show_message_to_courier: "Show your message",
        message_to_courier: "Message to courier",
        message_to_courier_description:
            "Send additional instructions about handover. Couriers can't reply.",
        message_placeholder: "For example: Please handover the package to my wife, doorbell Smiths",
        message_maximum_characters: "Enter up to {MAX_CHARS} characters",
        send_message: "Send message",
        send_message_failed: "Sending failed",
        message_sent: "Message sent",
        message_cant_be_edited: "The sent message can't be edited",
        back: "Back",
        czk: "CZK",
        pln: "PLN",
        tip_for_courier: "Tip for the courier",
        tip_for_courier_description: "Courier will receive 100% of the donated amount",
        tip_range_hint: "Valid range: {MIN} – {MAX} {CURRENCY}.",
        custom: "Custom",
        tip: "Tip",
        receipt: "Receipt",
        add_more: "Add more",
        ok: "OK",
        tip_payment_successful: "Payment successful",
        tip_payment_successful_text: "Thank you for the tip. We just sent a notice to the courier.",
        tip_payment_failed: "Payment failed",
        tip_payment_failed_text: "You can try again.",
        card_payment: "Pay with card",
        generic_error: "Something went wrong. Please try again.",
        try_again: "Try again",
        max_price_limit: "Tip can't be higher than {MAX_PRICE} CZK",
        courier_is_finishing_previous_job:
            "Courier is currently finishing previous job. Estimated arrival reflects this.",
        customer_service_contact_at_grid_page:
            "You can find customer support at <a>https://www.grid.online/contact</a>",
        contact_page_url: "https://www.grid.online/contact",
        delivery_ordered_by: "Delivery ordered by",
        how_was_the_ride: "How was the ride?",
        feedback_customer_service_info: "Our customer service handles every feedback",
        feedback_positive_title: "What did you especially enjoy?",
        feedback_neutral_title: "What should be improved for five stars?",
        feedback_negative_title: "We're sorry, what was wrong?",
        feedback_subtitle: "Please choose at least one reason. The rating is anonymous.",
        send_rating: "Send rating",
        sending: "Sending…",
        rating_failed: "Failed to send the rating. Please try again.",
        add_comment: "Add comment",
        comment: "Comment",
        thank_you_for_rating: "Thank you for the rating",
        how_was_the_delivery: "How was the delivery?",
        please_select_a_reason: "Please select a reason or add a comment",
    },
    pl: {
        ride_not_found: "Nie znaleziono przejazdu",
        loading: "Ładowanie…",
        delivery_arriving_time: "Przesyłka dotrze {time}",
        delivery_arriving_time_at: "Przesyłka dotrze około {time}",
        delivery_arriving_no_time: "Przesyłka jest w drodze",
        delivery_arriving_soon: "Przesyłka dotrze za chwilę",
        delivery_delay: "Opóźnienie doręczenia {delay} min",
        delivery_finished: "Przesyłka została doręczona",
        delivery_undelivered:
            "Nie udało się doręczyć przesyłki. Kurier Cię nie zastał lub doręczenie zostało anulowane.",
        delivery_redirected: "Przesyłka jest w drodze do punktu odbioru",
        delivery_delivered_to_pudo: "Przesyłka czeka w punkcie odbioru",
        delivery_arrived: "Kurier jest na miejscu doręczenia",
        delivery_cancelled:
            "Nie udało się doręczyć przesyłki. Kurier Cię nie zastał lub doręczenie zostało anulowane.",
        order_cancelled: "Zamówienie zostało anulowane",
        order_cancelled_by_courier: "Zamówienie zostało anulowane przez kuriera",
        pickup_arriving_time: "Odbiór przesyłki {time}",
        pickup_arriving_time_at: "Odbiór przesyłki około {time}",
        pickup_arriving_no_time: "Kurier jest w drodze",
        pickup_arriving_soon: "Odbiór przesyłki za chwilę",
        pickup_delay: "Opóźnienie odbioru {delay} min",
        pickup_finished: "Przesyłka została odebrana",
        pickup_undelivered: "Odbiór został anulowany",
        pickup_arrived: "Kurier jest na miejscu",
        pickup_cancelled: "Odbiór został anulowany",
        black: "Czarny",
        blue: "Niebieski",
        brown: "Brązowy",
        green: "Zielony",
        orange: "Pomarańczowy",
        purple: "Fioletowy",
        red: "Czerwony",
        silver: "Srebrny",
        white: "Biały",
        yellow: "Żółty",
        car_name: "{brand} {model}",
        destination: "Cel",
        pcs: "szt.",
        call: "Zadzwoń do kuriera",
        call_courier: "Zadzwoń do kuriera",
        privacy_policy: "Polityka prywatności",
        package_redirecting: "Instrukcje dotyczące odbioru otrzymasz od firmy {ordererName}.",
        pudo_name: "Punkt odbioru",
        pudo_address: "Adres",
        show_pudo_image: "Pokaż zdjęcie",
        hide_pudo_image: "Ukryj zdjęcie",
        code: "Kod",
        call_courier_dialog_title_ivr_disabled:
            "Do kuriera możesz zadzwonić tylko z numeru podanego w zamówieniu",
        call_courier_dialog_title_ivr_enabled: "Zadzwoń do kuriera",
        call_courier_dialog_subtitle:
            "Dla lepszej ochrony prywatności nie wyświetlamy prawdziwych numerów telefonów.",
        code_for_communication: "Kod do komunikacji",
        pickup: "Odbiór",
        delivery_drop_off: "Doręczenie",
        stop: "Przystanek",
        depot: "Przechowanie",
        return: "Zwrot",
        delivered: "Doręczono",
        undelivered: "Nie doręczono",
        picked_up: "Odebrano",
        returned: "Zwrócono",
        understand: "Rozumiem",
        message_sent_title: "Wiadomość wysłana",
        message_sent_info: "Kurier otrzymał Twoją wiadomość.",
        message_sent_description: "Wysłanej wiadomości nie można edytować.",
        redirected: "Przekierowano",
        delivered_to_pudo: "Doręczono do punktu odbioru",
        courier_cancelled: "Doręczenie anulowane",
        cancelled: "Anulowano doręczenie na Twoją prośbę",
        cancelled_info:
            "Przesyłka wraca do firmy {ordererName}. Napisz nam, co się stało. Pomożesz nam ulepszyć naszą usługę.",
        redirected_to_pudo: "Przekierowano doręczenie na Twoją prośbę",
        redirected_to_pudo_info:
            "Twoja przesyłka będzie czekać w najbliższym dostępnym punkcie odbioru lub automacie paczkowym. Dokładne informacje o odbiorze przekaże Ci firma {ordererName}.",
        delay: "opóźnienie",
        soon: "za chwilę",
        arrived: "na miejscu",
        change_title_question: "Jak chcesz zmienić doręczenie?",
        change_delivery_intent: "Zmiana doręczenia",
        cancel_title_question: "Anuluj doręczenie",
        cancel_delivery_intent: "Anuluj doręczenie",
        cancel_delivery_description:
            "Zmień dzisiejsze doręczenie, a kurier nie będzie Cię niepotrzebnie szukał.",
        cancel_delivery_question: "Dlaczego zmieniasz doręczenie?",
        cancel_delivery: "Anuluj doręczenie",
        confirm_redirect_to_pudo: "Potwierdź zmianę",
        select_the_reason: "Wybierz powód",
        redirect_info: "Najbliższy dostępny punkt odbioru wskazuje firma {ordererName}.",
        cancel_failed: "Anulowanie nie powiodło się",
        show_message_to_courier: "Pokaż swoją wiadomość",
        message_to_courier: "Wiadomość dla kuriera",
        message_to_courier_description:
            "Wyślij dodatkowe instrukcje dotyczące przekazania przesyłki. Kurierzy nie mogą odpowiedzieć.",
        message_placeholder: "Na przykład: Przesyłkę odbierze żona, dzwonek Kowalscy",
        message_maximum_characters: "Wpisz maksymalnie {MAX_CHARS} znaków",
        send_message: "Wyślij wiadomość",
        send_message_failed: "Wysyłanie nie powiodło się",
        message_sent: "Wiadomość wysłana",
        message_cant_be_edited: "Wysłanej wiadomości nie można edytować",
        back: "Wstecz",
        czk: "CZK",
        pln: "zł",
        tip_for_courier: "Napiwek dla kuriera",
        tip_for_courier_description: "Kurier otrzyma 100% przekazanej kwoty",
        tip_range_hint: "Dozwolony zakres: {MIN} – {MAX} {CURRENCY}.",
        custom: "Inna",
        tip: "Napiwek",
        receipt: "Potwierdzenie",
        add_more: "Dodaj kolejny",
        ok: "OK",
        tip_payment_successful: "Płatność udana",
        tip_payment_successful_text:
            "Dziękujemy za napiwek. Właśnie wysłaliśmy powiadomienie kurierowi.",
        tip_payment_failed: "Płatność nie powiodła się",
        tip_payment_failed_text: "Możesz spróbować ponownie.",
        card_payment: "Zapłać kartą",
        generic_error: "Coś poszło nie tak. Spróbuj ponownie.",
        try_again: "Spróbuj ponownie",
        max_price_limit: "Napiwek nie może być wyższy niż {MAX_PRICE} zł",
        courier_is_finishing_previous_job:
            "Kurier właśnie kończy poprzednie zlecenie. Dotrze na miejsce w szacowanym czasie.",
        customer_service_contact_at_grid_page:
            "Obsługę klienta znajdziesz na <a>www.grid.online/contact</a>",
        contact_page_url: "https://www.grid.online/contact",
        delivery_ordered_by: "Doręczenie zamówione przez",
        how_was_the_ride: "Jak minął przejazd?",
        feedback_customer_service_info: "Nasza obsługa klienta zajmuje się każdą opinią",
        feedback_positive_title: "Co szczególnie Ci się podobało?",
        feedback_neutral_title: "Czego zabrakło do 5 gwiazdek?",
        feedback_negative_title: "Przykro nam. Co poszło nie tak?",
        feedback_subtitle: "Wybierz co najmniej jeden powód. Ocena jest anonimowa.",
        send_rating: "Wyślij ocenę",
        sending: "Wysyłanie…",
        rating_failed: "Nie udało się wysłać oceny. Spróbuj ponownie.",
        add_comment: "Dodaj komentarz",
        comment: "Komentarz",
        thank_you_for_rating: "Dziękujemy za ocenę",
        how_was_the_delivery: "Jak przebiegło doręczenie?",
        please_select_a_reason: "Wybierz powód lub dodaj komentarz",
    },
};

export function getLanguage() {
    const allowedLanguages = ["cs", "pl", "en"];
    const language = navigator.language.split("-")[0];
    // we don't maintain Slovak translations, Czech is the closest
    if (language === "sk") return "cs";
    return allowedLanguages.indexOf(language) > -1 ? language : "en";
}

export function getMessages() {
    return messages[getLanguage()];
}
